import { ENV } from '@/constants';
import { exploreSchemaItemList } from '../exploreSchema';

export const schemaObject_PhotoToPainting = {
	'@context': 'https://schema.org',
	'@graph': [
		{
			'@type': 'WebPage',
			'@id': 'https://liftapp.ai/photo-to-painting',
			name: 'Photo to Painting AI — Turn Image Into Painting online',
			description:
				"Transform picture to painting instantly with Lift's AI oil painting filter. No watermark. Upload a photo, apply a filter, and get gallery-worthy results perfect for printing or gifting.",
			url: 'https://liftapp.ai/photo-to-painting',
			image: 'https://liftapp.ai/seo-image.webp',
			mainEntity: [
				{ '@id': 'https://liftapp.ai/photo-to-painting#product' },
				{ '@id': 'https://liftapp.ai/photo-to-painting#howto' },
				{ '@id': 'https://liftapp.ai/photo-to-painting#benefits' },
				{ '@id': 'https://liftapp.ai/photo-to-painting#faq' },
				{ '@id': 'https://liftapp.ai/photo-to-painting#why-lift' },
				{ '@id': 'https://liftapp.ai/photo-to-painting#explore-tools' },
				{ '@id': 'https://liftapp.ai/photo-to-painting#all-in-one' },
			],
		},
		// product
		{
			'@type': 'Product',
			'@id': 'https://liftapp.ai/photo-to-painting#product',
			name: 'Photo to Painting AI — Turn Image Into Painting online',
			description:
				'Turn your favorite photos into stunning, personalized paintings! With our AI Photo to Painting tool, instantly transform family memories, portraits, or any image into beautiful artistic masterpieces. Perfect for gifts, home decor, or simply celebrating your special moments — no painting skills needed!',
			url: 'https://liftapp.ai/photo-to-painting',
			fileFormat: ['image/jpeg', 'image/png', 'image/webp'],
			memoryRequirements: 'Max file size: 20MB',
			brand: {
				'@type': 'Brand',
				name: 'Lift',
			},
			aggregateRating: {
				'@type': 'AggregateRating',
				ratingValue: '4.8',
				reviewCount: 130000,
				bestRating: '5',
				worstRating: '1',
			},
			interactionStatistic: [
				{
					'@type': 'InteractionCounter',
					interactionType: { '@type': 'InstallAction' },
					userInteractionCount: 13000000,
				},
			],
		},
		// howto
		{
			'@type': 'HowTo',
			'@id': 'https://liftapp.ai/photo-to-painting#howto',
			name: 'How it works',
			step: [
				{
					'@type': 'HowToStep',
					position: 1,
					name: 'Upload your photos',
					text: "Choose a photo from your device or take one using Lift's app",
				},
				{
					'@type': 'HowToStep',
					position: 2,
					name: 'AI applies artistic painting style',
					text: 'Instantly convert your photo into personalized painting',
				},
				{
					'@type': 'HowToStep',
					position: 3,
					name: 'Customize adjustments',
					text: 'Fine-tune your image with easy-to-use editing tools',
				},
				{
					'@type': 'HowToStep',
					position: 4,
					name: 'Download and use',
					text: 'Download your image or publish it straight to your social feeds',
				},
			],
		},
		// benefit
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/photo-to-painting#benefits',
			name: 'Who can benefit from AI Photo to Painting Generator?',
			description:
				"Lift's AI Photo to Painting Generator is useful for anyone wanting to create meaningful, artistic gifts, home decorators, social media users, photographers, and memory keepers.",
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Perfect for anyone wanting to create meaningful, artistic gifts without hiring an artist',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Home decorators can turn family photos into beautiful wall art for personalized interiors',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Social media users can elevate their feed with artistic, museum-quality visuals',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Photographers can offer painted portrait options to clients without manual editing',
				},
				{
					'@type': 'ListItem',
					position: 5,
					name: 'Memory keepers can transform cherished moments into timeless, heirloom-quality artwork',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/benefits.3da6de53.webp',
				name: 'Oil Painting Filter',
				description: 'Oil Painting Filter',
			},
		},

		// faq
		{
			'@type': 'FAQPage',
			'@id': 'https://liftapp.ai/photo-to-painting#faq',
			mainEntity: [
				{
					'@type': 'Question',
					name: 'What is Lift AI Photo to Painting Generator?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Lift AI Photo to Painting Generator is an online tool that transforms your photos into stunning painted artwork — perfect for gifts, home decor, prints, or creative projects with authentic oil painting, watercolor, and classic art styles.',
					},
				},
				{
					'@type': 'Question',
					name: 'How does Lift AI Photo to Painting Generator work?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Our AI analyzes your photo with deep learning, keeps your facial features and composition accurate, and reimagines them in realistic painting styles with artistic brushstrokes, textures, colors, and details. Everything is automatic — no manual editing or painting skills needed.',
					},
				},
				{
					'@type': 'Question',
					name: 'Can I convert any photo into AI Painting?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: "Yes. Lift works with portraits, landscapes, pets, objects, and any image type. The AI adapts to your photo's content and applies artistic transformations that enhance composition, color, and style while keeping the essence of your original image.",
					},
				},
				{
					'@type': 'Question',
					name: 'Can I download the results without a watermark?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Absolutely. All images generated or edited in Lift can be exported without watermark when you are on the Pro plan. Download them in high-res PNG or JPG — ready for printing, framing, social media, or gifting.',
					},
				},
			],
		},

		// why lift
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/photo-to-painting#why-lift',
			name: "Why Lift's AI Photo to Painting Generator stands out",
			description:
				"Lift's AI Photo to Painting Generator combines professional-grade AI, ease of use, and affordability — making it a trusted choice for millions of users worldwide.",
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'High-quality results',
					description:
						'AI-powered technology delivers professional-grade visuals every time',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Intelligent rendering',
					description:
						'AI tailors the effect to the scene and subject for optimal results',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Cross-platform support',
					description: 'Available on iOS, Android, and Web for seamless access',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Budget-friendly',
					description:
						'Save on costly designers with an affordable and intuitive tool',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/whyUse.ae83a89c.webp',
				name: 'Picture To Painting',
				description: 'Picture To Painting',
			},
		},
		// explore
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/photo-to-painting#explore-tools',
			name: 'Explore the AI tools',
			description:
				'A curated list of AI-powered tools for image generation, enhancement, background removal, and more – all available on Lift.',
			itemListOrder: 'Unordered',
			...exploreSchemaItemList,
		},

		{
			'@type': 'SoftwareApplication',
			'@id': 'https://liftapp.ai/photo-to-painting#all-in-one',
			name: 'Try Lift – AI Content Creation Tools',
			description:
				'Your all-in-one tools to create, edit, and elevate your content. Create stunning content with AI tools, templates, and editing features effortlessly.',
			operatingSystem: 'iOS, Android, Web',
			applicationCategory: 'MultimediaApplication',
			url: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
			applicationSubCategory: 'Content Creation',
			publisher: {
				'@type': 'Organization',
				name: 'Lift',
				url: 'https://liftapp.ai',
			},
			potentialAction: [
				{
					'@type': 'ViewAction',
					name: 'Open Web App',
					target: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
				},
			],
		},

		{
			'@type': 'BreadcrumbList',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Home',
					item: 'https://liftapp.ai',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Photo to Painting',
					item: 'https://liftapp.ai/photo-to-painting',
				},
			],
		},
	],
};
